import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import { Alert } from '@material-ui/lab';
import React, { useCallback, useState } from 'react';
import { useObservable } from 'react-use-observable';
import { PartnerRefundRequestModal } from 'v2/components/Shared/RefundReason';
import { EChargeType } from 'v2/interfaces/product';
import { ERequestStatus } from 'v2/interfaces/shopping';
import { refundRequestFactory } from 'v2/services/shopping/refundRequest';

import type { IInvoice } from 'v2/interfaces/invoice';
import type { ICanRefund, IRefundRequest } from 'v2/interfaces/shopping';

import useStyles from './styles';

interface IProps {
  invoice: IInvoice;
  refund: ICanRefund;
}

const RefundInvoicePartnerButton = ({ invoice, refund }: IProps) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const [finish, setFinish] = useState<boolean>(false);
  const invoiceId = invoice.invoice_id ?? invoice.id;
  const [refundRequest] = useObservable<IRefundRequest>(() => refundRequestFactory.partnerFindRefundByInvoiceId(invoiceId), [invoice]);

  const openRefundRequestModal = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const closeRefundRequestModal = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const onRefundRequestMade = useCallback(() => {
    setFinish(true);
    setOpen(false);
  }, []);

  if (!refundRequest || !refund) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress size={20} />
      </div>
    );
  }

  const shouldntShowRefundButton =
    refundRequest.exist && refundRequest.status != ERequestStatus.PENDING && refundRequest.status != ERequestStatus.REPROVED;

  if (shouldntShowRefundButton) return null;

  const shouldShowAnalyze =
    refundRequest.exist && invoice.comission_type.toLowerCase() === 'produtor' && refundRequest.status != ERequestStatus.REPROVED;
  const disabled = !refund.can_refund || finish;
  const reason = refund.can_refund_reason || '';

  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        {shouldShowAnalyze && (
          <Grid item xs={12}>
            <Alert severity='warning'>Há uma solicitação de reembolso para essa fatura</Alert>{' '}
          </Grid>
        )}
        {invoice.product.charge_type !== EChargeType.FREE && (
          <Tooltip title={reason} placement='top'>
            <Grid item xs={12} md={shouldShowAnalyze ? 6 : 12}>
              <Button disabled={disabled} color='primary' className={classes.refundButton} onClick={openRefundRequestModal} fullWidth>
                Reembolsar Fatura
              </Button>
            </Grid>
          </Tooltip>
        )}
        {shouldShowAnalyze && (
          <Grid item xs={12} md={6}>
            <Button
              color='primary'
              className={classes.analyzeButton}
              variant='contained'
              onClick={() => window.open('/producer/request-management')}
              fullWidth
            >
              Analisar
            </Button>
          </Grid>
        )}
      </Grid>

      <PartnerRefundRequestModal
        open={open}
        invoiceId={invoice.invoice_id ?? invoice.id}
        contractId={invoice.contract_id}
        onClose={closeRefundRequestModal}
        onFinish={onRefundRequestMade}
      />
    </Grid>
  );
};

export default RefundInvoicePartnerButton;
